// extracted by mini-css-extract-plugin
export default {"signin":"signin_signin__fWCgT","container":"signin_container__wrW7q","sso":"signin_sso__CDxIX","containerImage":"signin_containerImage__hAhfH","logo":"signin_logo__wEmeR"};